module.exports = __webpack_public_path__ + "img/frame (198).dc72d019.jpg";